import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function DirectorSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="director" className="bg-white py-16 md:py-24">
      <div ref={ref} className={`w-full px-4 md:px-8 max-w-5xl mx-auto scroll-reveal ${isVisible ? 'visible' : ''}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="order-2 md:order-1 scroll-reveal-item delay-2">
            <img
              src="./images/takimoto.jpg"
              alt="滝本裕之院長"
              className="w-full max-w-sm mx-auto rounded-xl object-cover"
              style={{ aspectRatio: '4/5' }}
            />
          </div>
          <div className="order-1 md:order-2 scroll-reveal-item delay-3">
            <p className="text-clinic-terracotta text-sm font-bold mb-2">
              開業21年。守谷の皆様に支えられてきました
            </p>
            <h2 className="font-serif text-xl md:text-3xl font-bold text-clinic-dark mb-6">
              ひろカイロ整体院 院長：
              <br />
              滝本裕之
            </h2>
            <div className="space-y-4 text-clinic-dark text-sm md:text-base leading-relaxed">
              <p>
                私自身、かつては体の不調に悩んだ経験があります。「どこに行っても良くならない」という不安な気持ちが、痛いほどよくわかります。
              </p>
              <p>
                21年間、守谷の地で多くの女性の悩みと向き合ってきました。あなたの不安に寄り添い、丁寧にお話をお聞きします。
              </p>
              <p className="font-medium text-clinic-green-dark">
                どうぞ安心してお越しください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}